import { useState } from "react"
import { supabase } from '../supabase';
import '../styles/Account.css';

const AccountPage = ({ profile, session }) => {

    const [hoveredSection, setHoveredSection] = useState(null);
    const user = session?.user

    const [pField, setPField] = useState("Change")
    const [pFieldColor, setPFieldColor] = useState("")

    function timeAgo(timestamp) {
        const now = new Date();
        const past = new Date(timestamp);
        const diffMs = now - past;

        const minutes = Math.floor(diffMs / (1000 * 60));
        const hours = Math.floor(diffMs / (1000 * 60 * 60));

        if (minutes < 1) return "now";
        if (minutes < 60) return `${minutes} minute${minutes !== 1 ? "s" : ""} ago`;
        return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
    }

    const handleReset = async (e) => {
        setPField("Loading...")

        const { error } = await supabase.auth.resetPasswordForEmail(user?.email);

        if (error) {
            setPField(error.message)
            setPFieldColor("redpass")
        } else {
            setPField("Reset email has been sent")
            setPFieldColor("greenpass")
        }

        setTimeout(() => {
            setPField("Change");
            setPFieldColor("");
        }, 5000);
    };

    return (
        <div className="mainAccount">
            <div className="accountContainer">
                <div className="accountHeader">
                    <h1>Account Settings</h1>
                    <p className="headerSubtext">Manage your account information and preferences</p>
                </div>

                <div className="accountSections">
                    <div 
                        className={`accountSection ${hoveredSection === 'profile' ? 'hovering' : ''}`}
                        onMouseEnter={() => setHoveredSection('profile')}
                        onMouseLeave={() => setHoveredSection(null)}
                    >
                        <div className="sectionHeader">
                            <h2>Profile Information</h2>
                        </div>
                        <div className="sectionContent">
                            <div className="infoRow">
                                <span className="infoLabel">Email</span>
                                <span className="infoValue">{user?.email}</span>
                            </div>
                            <div className="infoRow">
                                <span className="infoLabel">Role</span>
                                <span className="roleBadge">{profile?.role}</span>
                            </div>
                            <div className="infoRow">
                                <span className="infoLabel">Member Since</span>
                                <span className="infoValue">{
                                new Date(user?.created_at).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric"
                                    })
                                    }</span>
                            </div>
                        </div>
                    </div>

                    <div 
                        className={`accountSection ${hoveredSection === 'security' ? 'hovering' : ''}`}
                        onMouseEnter={() => setHoveredSection('security')}
                        onMouseLeave={() => setHoveredSection(null)}
                    >
                        <div className="sectionHeader">
                            <h2>Security</h2>
                        </div>
                        <div className="sectionContent">
                            <div className="infoRow">
                                <span className="infoLabel">Password</span>
                                <span 
                                className={`statusBadge disabled ${pField === "Change" ? "changep" : ""} ${pFieldColor}`}
                                onClick={() => {
                                    if (pField === "Change") {
                                        handleReset()
                                    }
                                }}
                                >{pField}</span>
                            </div>
                            <div className="infoRow">
                                <span className="infoLabel">Confirmed Email</span>
                                <span className="statusBadge enabled">No</span>
                            </div>
                            <div className="infoRow">
                                <span className="infoLabel">Last Login</span>
                                <span className="infoValue">{timeAgo(user?.last_sign_in_at)}</span>
                            </div>
                        </div>
                    </div>

                    <div 
                        className={`accountSection ${hoveredSection === 'preferences' ? 'hovering' : ''}`}
                        onMouseEnter={() => setHoveredSection('preferences')}
                        onMouseLeave={() => setHoveredSection(null)}
                    >
                        <div className="sectionHeader">
                            <h2>Preferences</h2>
                        </div>
                        <div className="sectionContent">
                            <div className="infoRow">
                                <span className="infoLabel">Timezone</span>
                                <span className="infoValue">Eastern Time (ET)</span>
                            </div>
                            <div className="infoRow">
                                <span className="infoLabel">Email Notifications</span>
                                <span className="statusBadge enabled">Off</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountPage;